import type { Session } from "./session";

/** The person the sample data is for. A placeholder, like the data. */
export const SAMPLE_SESSION: Session = {
    userId: "user_sample",
    email: "dallin@example.com",
    firstName: "Dallin",
    lastName: "W",
    signOut: () => {},
};

/**
 * Whether the sample is looked at signed out: `?sample=signedout`. Read
 * once, when the page loads, so moving between the signed-out pages keeps
 * it. Signing in from there reloads the sample signed in.
 */
export function sampleSignedOut(search: string): boolean {
    return new URLSearchParams(search).get("sample") === "signedout";
}
